import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c2b6b84c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "new-common-popup xag-flex-vertical" }
const _hoisted_2 = { class: "xag-flex-1 content xag-flex-vertical" }
const _hoisted_3 = { class: "e-item xag-flex-vertical" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "e-title" }, "1.您对本次维修服务的服务时效是否满意？", -1))
const _hoisted_5 = { class: "evaluateItem-box" }
const _hoisted_6 = { class: "e-item xag-flex-vertical fix-e-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "e-title" }, "2.您对本次维修服务的服务体验是否满意？", -1))
const _hoisted_8 = { class: "evaluateItem-box" }
const _hoisted_9 = { class: "e-item xag-flex-vertical fix-e-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "e-title" }, "3.您对维修总体质量满意吗？", -1))
const _hoisted_11 = { class: "evaluateItem-box" }
const _hoisted_12 = { class: "e-item xag-flex-vertical fix-e-item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "e-title" }, "4.您对维修服务还有其他建议吗？", -1))
const _hoisted_14 = { class: "text-area-box xag-flex-1" }
const _hoisted_15 = {
  key: 0,
  class: "evaluate-time"
}

import { withDefaults, ref } from 'vue'
import { Field } from 'vant'
import {
  NewEvaluateData,
  EvaluateItemType,
  NewEvaluateDataScoreKey,
} from '@/types/malfunction-repair'
import EvaluateItem from './components/evaluate-item.vue'
type EvaluateItemArr = Array<EvaluateItemType>


export default /*#__PURE__*/_defineComponent({
  __name: 'service-order-evaluation',
  props: {
    isEnd: { type: Boolean },
    newEveluateData: null
  },
  emits: ["update:newEveluateData"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:newEveluateData', data: NewEvaluateData): void
}), expose: any, slots: any, attrs: any }) {

const Props = __props as { isEnd: boolean, newEveluateData: NewEvaluateData };




let evaluateItemArrConfig = ref<Array<EvaluateItemArr>>([
  [
    {
      title: '维修时长',
      value: 0,
      key: 'repair_time',
    },
  ],
  [
    {
      title: '接待人员服务态度',
      value: 0,
      key: 'receptionist_service_attitude',
    },
    {
      title: '维修人员服务态度',
      value: 0,
      key: 'repair_service_attitude',
    },
    {
      title: '环境整洁度',
      value: 0,
      key: 'environment',
    },
    {
      title: '流程清晰,及时指导',
      value: 0,
      key: 'process',
    },
  ],
  [
    {
      title: '问题得到解決',
      value: 0,
      key: 'problem_solved',
    },
    {
      title: '定责/定损清晰准确',
      value: 0,
      key: 'responsibility_clear',
    },
    {
      title: '维修原因明确',
      value: 0,
      key: 'repair_reason_clear',
    },
    {
      title: '维修金额合理,及时指导',
      value: 0,
      key: 'reasonable_amount',
    },
  ],
])

function updateNewEveluateDataHandle(value: number | string, key: string) {
  emit('update:newEveluateData', {
    ...Props.newEveluateData,
    [key]: value,
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(evaluateItemArrConfig)[0], (item, index) => {
            return (_openBlock(), _createBlock(EvaluateItem, {
              "is-end": __props.isEnd,
              score: __props.newEveluateData[item.key as keyof NewEvaluateDataScoreKey],
              "onUpdate:score": (value) => updateNewEveluateDataHandle(value, item.key),
              "is-last": index === _unref(evaluateItemArrConfig)[0].length - 1,
              title: item.title,
              key: item.key
            }, null, 8, ["is-end", "score", "onUpdate:score", "is-last", "title"]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(evaluateItemArrConfig)[1], (item, index) => {
            return (_openBlock(), _createBlock(EvaluateItem, {
              "is-end": __props.isEnd,
              score: __props.newEveluateData[item.key as keyof NewEvaluateDataScoreKey],
              "onUpdate:score": (value) => updateNewEveluateDataHandle(value, item.key),
              "is-last": index === _unref(evaluateItemArrConfig)[1].length - 1,
              title: item.title,
              key: item.key
            }, null, 8, ["is-end", "score", "onUpdate:score", "is-last", "title"]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(evaluateItemArrConfig)[2], (item, index) => {
            return (_openBlock(), _createBlock(EvaluateItem, {
              "is-end": __props.isEnd,
              score: __props.newEveluateData[item.key as keyof NewEvaluateDataScoreKey],
              "onUpdate:score": (value) => updateNewEveluateDataHandle(value, item.key),
              "is-last": index === _unref(evaluateItemArrConfig)[2].length - 1,
              title: item.title,
              key: item.key
            }, null, 8, ["is-end", "score", "onUpdate:score", "is-last", "title"]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_unref(Field), {
            modelValue: __props.newEveluateData.appraise,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => updateNewEveluateDataHandle(value, 'appraise')),
            rows: "6",
            maxlength: __props.isEnd ? undefined : 120,
            "show-word-limit": "",
            type: "textarea",
            placeholder: "请输入",
            readonly: __props.isEnd
          }, null, 8, ["modelValue", "maxlength", "readonly"])
        ])
      ])
    ]),
    (__props.isEnd)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, "评价时间：" + _toDisplayString(__props.newEveluateData.created_at), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})